import { z } from 'zod'
import { FirestoreTimestamp } from './utils'

// Hierarchical Site Collection (companies/{companyId}/sites/{siteId})
export const Site = z.object({
  companyId: z.string().min(1, 'Company ID is required'),
  name: z.string(),
  address: z.string(),
  city: z.string(),
  state: z.string(),
  zip: z.string(),
  phone: z.string().optional(),
  department: z.string().optional(),

  // Relationship fields
  customerOrganizationId: z.string().nullable(),
  workRouteIds: z.array(z.string()).default([]),

  // De-normalized for offline access
  // TODO: This currently is not updated
  unitCount: z.number().default(0),

  // Archiving - hidden from active views, data preserved
  archivedAt: FirestoreTimestamp.nullable().default(null),

  // Maintenance completion tracking (updated by triggers)
  currentMonthMaintenanceCompletion: z
    .object({
      totalMaintenanceTasks: z.number().default(0),
      completedMaintenanceTasks: z.number().default(0),
      // Timestamp of last incremental update (for race detection)
      lastIncrementalAt: FirestoreTimestamp.optional(),
      // Timestamp of last full recalculation
      lastRecalcAt: FirestoreTimestamp.optional(),
    })
    .optional(),

  // Audit fields
  createdAt: FirestoreTimestamp,
  updatedAt: FirestoreTimestamp,
})

export type Site = z.infer<typeof Site>
